import React from "react";
import HeroBanner from "./HeroBanner";
import Sportsbook from "./Sportsbook.jsx";

const Betting = () => {
  return (
    <div className="betting-page">
      {/* <HeroBanner /> */}
      <Sportsbook />
    </div>
  );
};

export default Betting;
